import { FinalAccessStatus, Screen, UserType, UserTypeScreen } from "../../entities/NSwagGenerated"
import { appAuth } from "../auth/appAuth"
// import { OktaAuth } from '@okta/okta-auth-js'
import { oktaAuth } from "../auth/oktaAuth"

export enum PageAccess {
	Create,
	Read,
	Update,
	Archive,
	Delete,
}

export class PersonSessionData {
	id: string
	firstName: string
	lastName: string
	fullName: string
	email: string
	isAdmin: boolean
	screens: UserTypeScreen[]
	screenAccess: FinalAccessStatus[]
	role: string
}

export abstract class SessionInfo {
	public static async checkOktaStatus(): Promise<Boolean> {
		oktaAuth.signInWithRedirect().then(async () => {
			const token = await oktaAuth.getAccessToken()
			// console.log("OktaStatus token ", token)

			if (token) {
				localStorage.setItem("token", token)

				let result = await appAuth.loginToAppWithOktaToken(token).then((callback) => {
					if (callback != "ok") {
						sessionStorage.setItem("error", callback)
						return false
					} else {
						return true
					}
				})
				return result
			} else {
				return false
			}
		})

		return true
	}

	public static currentUser(): PersonSessionData {
		if (!localStorage.getItem("PersonSessionData")) SessionInfo.checkOktaStatus()
		const sessionData: PersonSessionData = JSON.parse(localStorage.getItem("PersonSessionData"))
		return sessionData
	}

	public static currentUserIsAdmin(): boolean {
		if (!localStorage.getItem("PersonSessionData")) SessionInfo.checkOktaStatus()
		const sessionData: PersonSessionData = JSON.parse(localStorage.getItem("PersonSessionData"))
		return sessionData.isAdmin
	}

	public static currentUsergetScreens(): UserTypeScreen[] {
		if (!localStorage.getItem("PersonSessionData")) SessionInfo.checkOktaStatus()
		const sessionData: PersonSessionData = JSON.parse(localStorage.getItem("PersonSessionData"))
		return sessionData.screens
	}

	public static hasRightsToScreenOLD(screen: string, access: PageAccess): boolean {
		//if (!localStorage.getItem("PersonSessionData")) await SessionInfo.checkAuth0Status()
		let localStoragePersonData = localStorage.getItem("PersonSessionData")

		if (localStoragePersonData == null) {
			return false
		}

		const sessionData: PersonSessionData = JSON.parse(localStoragePersonData)
		const screenRights = sessionData.screens.find((s) => s.screen.screenName == screen)
		if (screenRights != undefined && screenRights.accessType != null) {
			// console.log(
			// 	"rights check:",
			// 	PageAccess[access].toString().slice(0, 1),
			// 	"screen:",
			// 	screen,
			// 	"access",
			// 	screenRights.accessType,
			// 	"granted?:",
			// 	screenRights.accessType.indexOf(PageAccess[access].toString().slice(0, 1)) >= 0
			// )
			return screenRights.accessType.indexOf(PageAccess[access].toString().slice(0, 1)) >= 0
		} else {
			console.error(`unable to find access rights for screen ${screen}`)
			return false
		}
	}

	public static hasRightsToScreen(screen: string, access: PageAccess): boolean {
		//if (!localStorage.getItem("PersonSessionData")) await SessionInfo.checkAuth0Status()
		let localStoragePersonData = localStorage.getItem("PersonSessionData")

		if (localStoragePersonData == null) {
			return false
		}

		const sessionData: PersonSessionData = JSON.parse(localStoragePersonData)
		if (sessionData.isAdmin) {
			return true
		}
		const screenRights = sessionData.screenAccess.find((s) => s.screenName == screen)

		if (screenRights != undefined && screenRights.accessType != null) {
			return screenRights.accessType.indexOf(PageAccess[access].toString().slice(0, 1)) >= 0
		} else {
			console.error(`unable to find access rights for screen ${screen}`)
			return false
		}
	}
}
